import { Box } from "@material-ui/core";
import LoadingBox from "../LoadingBox";

export function renderLoadingOrError(loading: boolean, error?: any) {
	if (loading) {
		return (
			<Box width="100%" height="100vh">
				<LoadingBox />
			</Box>
		);
	}

	if (error) {
		return <p>{JSON.stringify(error)}</p>;
	}
	return <></>;
}
